export type MenuItemType = {
  id: number;
  path: string;
  notRender?: boolean;
  translateText: string;
};

export const MENU: MenuItemType[] = [
  {
    id: 1,
    path: '/',
    translateText: '',
  },
  {
    id: 2,
    path: '/brands',
    translateText: 'menu.Danh mục mua sắm',
  },
  {
    id: 3,
    path: '/partners',
    translateText: 'menu.Dành cho đối tác',
  },
  {
    id: 4,
    notRender: true,
    path: 'https://docs.fundiin.vn/v2',
    translateText: 'menu.Developers',
  },
  {
    id: 5,
    path: '/about',
    translateText: 'menu.Về Fundiin',
  },
  {
    id: 6,
    path: '/privacy',
    translateText: 'menu.privacy',
  },
  {
    id: 7,
    path: '/request-delete-account',
    translateText: 'menu.deleteAccount',
  },
];

export const DefaultLang = 'vi';

export const mediaMaxScreenPC = 3000;
export const mediaScreenTablet = 1199;
export const mediaScreenMobile = 833;
export const mediaMinScreenMobile = 325;
